/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPlanContainerRequest, ApiRequisition, ApiRequisitionContainerAction } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of RequisitionContainerActionsController.
 */
export class RequisitionContainerActionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /requisitions/{rootObjectId}/container_actions:plan
     */
    public plan(request: ApiPlanContainerRequest, rootObjectId: string): Promise<Result<ApiRequisition>> {
        return this.http.post<Result<ApiRequisition>, ApiPlanContainerRequest>(`/requisitions/${rootObjectId}/container_actions:plan`, request);
    }

    /**
     * Calls POST /requisitions/{rootObjectId}/container_actions:prefill
     */
    public createPrefilled(rootObjectId: string): Promise<Result<ApiRequisitionContainerAction>> {
        return this.http.post<Result<ApiRequisitionContainerAction>, undefined>(`/requisitions/${rootObjectId}/container_actions:prefill`, undefined);
    }

    /**
     * Calls GET /requisitions/{rootObjectId}/container_actions:query
     */
    public getListGet(pageSize: number, pageNo: number, rootObjectId: string): Promise<Result<ListInfo<ApiRequisitionContainerAction>>> {
        const query = new URLSearchParams();
        query.set('pageSize', `${pageSize}`);
        query.set('pageNo', `${pageNo}`);

        return this.http.get<Result<ListInfo<ApiRequisitionContainerAction>>>(`/requisitions/${rootObjectId}/container_actions:query`, query);
    }

    /**
     * Calls POST /requisitions/{rootObjectId}/container_actions:query
     */
    public getListPost(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiRequisitionContainerAction>>> {
        return this.http.post<Result<ListInfo<ApiRequisitionContainerAction>>, ListRequest>(`/requisitions/${rootObjectId}/container_actions:query`, listRequest);
    }

    /**
     * Calls GET /requisitions/{rootObjectId}/container_actions/{childId}
     */
    public get(childId: string, rootObjectId: string): Promise<Result<ApiRequisitionContainerAction>> {
        return this.http.get<Result<ApiRequisitionContainerAction>>(`/requisitions/${rootObjectId}/container_actions/${childId}`);
    }

    /**
     * Calls POST /requisitions/{rootObjectId}/container_actions
     */
    public add(childDto: ApiRequisitionContainerAction, rootObjectId: string): Promise<Result<ApiRequisitionContainerAction>> {
        return this.http.post<Result<ApiRequisitionContainerAction>, ApiRequisitionContainerAction>(`/requisitions/${rootObjectId}/container_actions`, childDto);
    }

    /**
     * Calls PUT /requisitions/{rootObjectId}/container_actions/{childId}
     */
    public put(childId: string, childDto: ApiRequisitionContainerAction, rootObjectId: string): Promise<Result<ApiRequisitionContainerAction>> {
        return this.http.put<Result<ApiRequisitionContainerAction>, ApiRequisitionContainerAction>(`/requisitions/${rootObjectId}/container_actions/${childId}`, childDto);
    }

    /**
     * Calls DELETE /requisitions/{rootObjectId}/container_actions/{childId}
     */
    public removeChild(childId: string, rootObjectId: string): Promise<Result<ApiRequisitionContainerAction>> {
        return this.http.delete<Result<ApiRequisitionContainerAction>>(`/requisitions/${rootObjectId}/container_actions/${childId}`);
    }
}
